import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Auth2Service } from 'src/app/tabms/services/Auth/auth2Service.service';

@Component({
  selector: 'app-user-setting',
  templateUrl: './user-setting.component.html',
  styleUrl: './user-setting.component.scss',
})
export class UserSettingComponent {
  constructor( 
    private auth2Service: Auth2Service,
    private router: Router,
    private translate: TranslateService
  ) {}

  myAccount$: Observable<string>;
  logout$: Observable<string>;

ngOnInit() {
  setTimeout(() => { // تأخير تعيين القيمة
    this.myAccount$ = this.translate.stream('myAccount'); 
    this.logout$ = this.translate.stream('logout'); 
  }); 
}
  logout() {
    this.auth2Service.logout();
    localStorage.clear();
    sessionStorage.clear();
  }

  navigateAccount() {
    this.router.navigate(['/account-settings']);
  }
}
